export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35_25483)">
        <path
          d="M6.6 2.82667C7.05889 2.71926 7.52871 2.66557 8 2.66667C12.6667 2.66667 15.3333 8.00001 15.3333 8.00001C14.9287 8.75708 14.446 9.46983 13.8933 10.1267M9.41334 9.41334C9.23024 9.60984 9.00944 9.76744 8.76411 9.87676C8.51877 9.98607 8.25394 10.0448 7.9854 10.0496C7.71686 10.0543 7.45011 10.0049 7.20108 9.90433C6.95204 9.80374 6.72582 9.65403 6.5359 9.46411C6.34599 9.27419 6.19627 9.04797 6.09568 8.79893C5.99509 8.5499 5.94569 8.28315 5.95043 8.01461C5.95517 7.74607 6.01394 7.48124 6.12326 7.23591C6.23257 6.99057 6.39017 6.76977 6.58667 6.58667M11.96 11.96C10.8204 12.8287 9.43274 13.3099 8 13.3333C3.33334 13.3333 0.666672 8.00001 0.666672 8.00001C1.49593 6.4546 2.6461 5.10441 4.04 4.04001L11.96 11.96Z"
          stroke="black"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.666672 0.666672L15.3333 15.3333"
          stroke="black"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35_25483">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
